import { getSingleSessionPrices } from "api/getSingleSessionPrices";
import { useMentorProducts, ParamsBase } from "hooks/useMentorProducts";

type Params = ParamsBase;

export function useSingleSessionPrices(arg: Params) {
	return useMentorProducts({
		...arg,
		requestType: "getMultipleSingleSessionPrices",
		fetchProducts: getSingleSessionPrices
	});
}
